<template>
  <div id="author-report">
    <div class="ipub-h2 mar-b-20">Manuscript No.{{responseData.code}} - <font class="ipub-h2"
            style="color:#1E1D40">{{ DECISION_STATUS[responseData.decisionStatus]}}</font>
    </div>
    <div class="content-bg"
         style="padding-bottom:30px">
      <!-- 稿件信息 -->
      <div class="mar-b-20">
        <div class="ipub-h3 line-h-40 mar-b-12 packUp ipub-cursor-pointer"
             @click="(e)=>{showManuscript = !showManuscript}">Manuscript Information
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate',showManuscript?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div class="part"
             v-if="showManuscript">
          <div class="flex mar-b-12 ipub-p2 fw-bd ">
            <div style="width:180px">Journal</div>
            <div class="ipub-p2"
                 style="width:calc(100% - 180px)">{{responseData.journal && responseData.journal.name || '--'}}</div>
          </div>
          <div class="flex mar-b-12 ipub-p2 fw-bd ">
            <div style="width:180px">Article Type</div>
            <div class="ipub-p2"
                 style="width:calc(100% - 180px)">{{responseData.details && responseData.details.type && responseData.details.type.name||'--'}}</div>
          </div>
          <div class="flex mar-b-12 ipub-p2 fw-bd ">
            <div style="width:180px">Article Title</div>
            <div class="ipub-p2"
                 style="width:calc(100% - 180px)">{{responseData.details && responseData.details.title||'--'}}</div>
          </div>
          <div class="flex mar-b-12 ipub-p2 fw-bd ">
            <div style="width:180px">Section</div>
            <div class="ipub-p2"
                 style="width:calc(100% - 180px)">{{responseData.details && responseData.details.section && responseData.details.section.name||'--'}}</div>
          </div>
          <div class="flex mar-b-12 ipub-p2 fw-bd ">
            <div style="width:180px">Special Issue</div>
            <div class="ipub-p2"
                 style="width:calc(100% - 180px)">{{responseData.details && responseData.details.special && responseData.details.special.titleText || '--'}}</div>
          </div>
          <div class="flex mar-b-12 ipub-p2 fw-bd ">
            <div style="width:180px">Abstract</div>
            <div class="ipub-p2"
                 style="width:calc(100% - 180px)">{{responseData.details&&responseData.details.summary||'--'}}</div>
          </div>
          <div class="flex mar-b-12 ipub-p2 fw-bd ">
            <div style="width:180px">Keywords</div>
            <div class="ipub-p2"
                 style="width:calc(100% - 180px)"
                 v-if="responseData && responseData.details &&responseData.details.keyword">
              <!-- <ipub-label :style="{margin: '5px 0 5px 8px'}"
                          v-for="(item, index) in responseData.details.keyword.split(',')"
                          :key="'specialIssue.keywords'+index"
                          size="small"
                          circle>{{item}}</ipub-label> -->
              {{responseData.details.keyword}}
            </div>
          </div>
          <div class="flex mar-b-12 ipub-p2 fw-bd ">
            <div style="width:180px">Funding</div>
            <div class="ipub-p2"
                 style="width:calc(100% - 180px)">
              <div v-if="responseData.foundationList && responseData.foundationList.length>0">
                <div v-for="(item,index) in responseData.foundationList"
                     :key="'funding'+index">{{item.name}} ({{item.code}})</div>
              </div>
              <span v-else>--</span>
            </div>
          </div>
          <div class="flex mar-b-12 ipub-p2 fw-bd ">
            <div style="width:180px">Discount</div>
            <div class="ipub-p2"
                 style="width:calc(100% - 180px)">
              <div v-if="responseData && responseData.discountDetailList &&responseData.discountDetailList.length>0">
                <font>{{responseData.__diacountTotal}} USD off</font>
              </div>
              <span v-else>--</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 作者信息 -->
      <div class="mar-b-30">
        <div class="ipub-h3 line-h-40 mar-b-12 ipub-cursor-pointer packUp"
             @click="(e)=>{showAuthor = !showAuthor}">Author(s)‘ Information
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate',showAuthor?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div class="part"
             v-if="showAuthor">
          <ul>
            <li class="mar-b-12 border-bottom author-list"
                v-for="(item,index) in responseData.authorList"
                v-show="(index!=0 && showMoreAuthor) || index===0"
                :key="item.id">
              <div class="ipub-p2 fw-bd mar-b-12">
                #{{item.seq}} {{title[item.titleCode]}} {{item.firstName}} {{item.lastName}}
                <ipub-label v-if="item.submited"
                            size="small"
                            class="mar-l-20"
                            type="theme">
                  Submitted Author
                </ipub-label>
                <ipub-label v-if="item.firsted"
                            size="small"
                            class="mar-l-20"
                            type="theme">
                  First Author
                </ipub-label>
                <ipub-label v-if="item.corresponded"
                            size="small"
                            class="mar-l-20"
                            type="theme">
                  Correspondence Author
                </ipub-label>
              </div>
              <div class="flex mar-b-12 ipub-p2 fw-bd ">
                <div style="width:180px">Email</div>
                <div class="ipub-p2"
                     style="width:calc(100% - 180px)">{{item.email || '--'}}</div>
              </div>
              <div class="flex mar-b-12 ipub-p2 fw-bd ">
                <div style="width:180px">Country / Terriory</div>
                <div class="ipub-p2"
                     style="width:calc(100% - 180px)">{{country[item.countryCode] || '--'}}</div>
              </div>
              <div class="flex mar-b-12 ipub-p2 fw-bd ">
                <div style="width:180px">
                  <ipub-icon type="iconORCID"
                             style="font-size:14px;color:#a6ce39"></ipub-icon> ORCID
                </div>
                <div class="ipub-p2"
                     style="width:calc(100% - 180px)">{{item.orcid ||'--'}}</div>
              </div>
              <div class="flex mar-b-12 ipub-p2 fw-bd ">
                <div style="width:180px">Affiliation(s)</div>
                <div class="ipub-p2"
                     style="width:calc(100% - 180px)">{{item.affiliation ||'--'}}</div>
              </div>
            </li>
            <div class="link-color ipub-p2 fw-bd ipub-cursor-pointer"
                 v-if="responseData &&responseData.authorList&&responseData.authorList.length>1"
                 @click="(e)=>{showMoreAuthor = !showMoreAuthor}">
              {{showMoreAuthor ?'Show Less':'Show More'}}
              <ipub-icon :class="['ipub-p5 mar-l-40 rotate',showMoreAuthor?'rotate-180':'']"
                         type="iconArrow" />
            </div>
          </ul>
        </div>
      </div>
      <!-- 附件 -->
      <div class="mar-b-30">
        <div class="ipub-h3 line-h-40 mar-b-12 ipub-cursor-pointer packUp"
             @click="(e)=>{showManuscriptFiles = !showManuscriptFiles}">Manuscript Files
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate',showManuscriptFiles?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div v-if="showManuscriptFiles"
             class="part">
          <div v-for="item in responseData.fileList"
               :key="item.id">
            <div class="flex mar-b-12 ipub-p2 fw-bd">
              <div style="width:180px"> {{item.item?item.item.typeName:'--'}}</div>
              <div style="width:calc(100% - 180px)"
                   class="ipub-c-p">
                <ipub-label class="ipub-p2"
                            type="link"
                            @click="download(item)">
                  {{item.name}}
                  <ipub-icon type="iconDownload1"
                             class="mar-l-10"></ipub-icon>
                </ipub-label>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- 建议审稿人 -->
      <div class="mar-b-30"
           v-if="responseData.reviewerList && responseData.reviewerList.length>0">
        <div class="ipub-h3 line-h-40 mar-b-12 ipub-cursor-pointer packUp"
             @click="(e)=>{showSuggestReview = !showSuggestReview}">Suggested & Opposed Reviewers
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate',showSuggestReview?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div v-if="showSuggestReview"
             class="part">
          <div class="flex">
            <div class="ipub-p2 fw-bd"
                 v-if="suggestList && suggestList.length>0">Suggest Reviewer</div>
            <div class="mar-l-20">
              <div v-for="(item,index) in suggestList"
                   :key="item.id+index"
                   class="mar-b-16">
                <div class="ipub-p2">{{item.firstName}} {{item.lastName}} ({{item.email}})</div>
                <span class="ipub-p2">{{item.affiliation}}</span>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="ipub-p2 fw-bd"
                 v-if="opposeList && opposeList.length>0">Oppose Reviewer</div>
            <div class="mar-l-20">
              <div v-for="(item,index) in opposeList"
                   :key="item.id+index"
                   class="mar-b-16">
                <div class="ipub-p2">{{item.firstName}} {{item.lastName}} ({{item.email}})</div>
                <span class="ipub-p2">{{item.affiliation}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- editor decision -->
      <div class="mar-b-30">
        <div class="ipub-h3 line-h-40 mar-b-12 ipub-cursor-pointer packUp"
             @click="(e)=>{showDecision = !showDecision}">{{responseData.decisionType==='FINAL_DECISION' ? 'Editor Decision': 'Academic Editor Decision'}}
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate',showDecision?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div v-if="showDecision"
             class="part">
          <div class="mar-b-20">
            <div class="ipub-p2 fw-bd mar-b-6">Comments to Author</div>
            <div class="ipub-p2"
                 v-if="responseData.authorNotes"
                 v-html="responseData.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
            <div class="ipub-p2 line-color"
                 v-else>No notes or comments.</div>
          </div>
          <div v-if="responseData.editorFileList && responseData.editorFileList.length>0">
            <div class="ipub-p2 fw-bd mar-b-6">Attachment(s)</div>
            <div class="file-contain">
              <ul class="flex file-list">
                <ipub-label style="margin-right:10px;cursor:pointer"
                            class="ipub-p2"
                            type="link"
                            @click="download(item,index)"
                            :key="'reviewerFileList'+index"
                            v-for="(item,index) in responseData.editorFileList">
                  {{item.name}}
                  <ipub-icon type="iconDownload1"
                             class="mar-l-10" />
                </ipub-label>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- Review Decision -->
      <div v-if="reviewReport && reviewReport.length>0">
        <div class="ipub-h3 line-h-40 mar-b-12 ipub-cursor-pointer packUp"
             @click="(e)=>{showReview = !showReview}">Reviewer(s) Decision
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate',showReview?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div v-if="showReview"
             class="part">
          <div class="flex title-tab mar-b-20">
            <div v-for="(item,index) in reviewReport"
                 :key="index"
                 @click="changeReport(item,index)"
                 :class="['ipub-p2 fw-bd','title-tab-item',index==activeKey ? 'title-tab-item-active':'']">
              Reviewer {{item.seq}}</div>
          </div>
          <div v-for="(itemRep,indexRep) in activeData.reviewerDecisionList"
               :key="indexRep">
            <div class="ipub-title-report ipub-p1 line-h-40 mar-b-10"
                 @click="showReport(itemRep,indexRep)">Report {{itemRep.sign}}
              <ipub-icon :class="['ipub-p5 mar-l-40 rotate',itemRep.showReport?'rotate-180':'']"
                         type="iconArrow" />
            </div>
            <div v-if="itemRep.showReport"
                 class="mar-b-20">
              <!-- <div class="mar-b-20">
                <div class="ipub-p2 fw-bd mar-b-4">
                  Custom Review Questions
                </div>
                <div class="question-answer">
                  <customerReviewQuestion :questionList="itemRep.questionList"></customerReviewQuestion>
                </div>
              </div> -->
              <div class="mar-b-20">
                <div class="ipub-p2 fw-bd fw-bd mar-b-4">
                  Comments to Author
                </div>
                <div v-if="itemRep.authorNotes"
                     class="ipub-p2"
                     v-html="itemRep.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>

                <div class="ipub-p2 line-color"
                     v-else>No notes or comments.</div>
              </div>
              <div class="mar-b-20"
                   v-show="itemRep.reviewerFileList && itemRep.reviewerFileList.length>0 && itemRep.reviewerFileList.some(item=>item.authorShowed)">
                <div class="ipub-p2 fw-bd mar-b-4">Attachment(s)
                </div>
                <div class="file-contain"
                     style="display:flex;flex-wrap:wrap;">
                  <template v-for="(itemfile,indexfile) in itemRep.reviewerFileList">
                    <template v-if="itemfile.authorShowed==true">
                      <ipub-label :key="itemfile.id"
                                  style="margin-right:10px;cursor:pointer"
                                  class="ipub-p2"
                                  type="link"
                                  @click="download(itemfile,indexfile)">
                        {{itemfile.name}}
                        <ipub-icon type="iconDownload1"
                                   class="mar-l-10" />
                      </ipub-label>
                    </template>
                  </template>
                </div>
              </div>
              <div class="mar-b-20"
                   v-if="itemRep.authorReply || (itemRep.authorReplyFileList&& itemRep.authorReplyFileList.length>0)">
                <div class="mar-b-20"
                     v-if="itemRep.authorReply">
                  <div class="ipub-p2 fw-bd fw-bd mar-b-4">Author Response to Report </div>
                  <div class="ipub-p2"
                       v-html="itemRep.authorReply?itemRep.authorReply.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' '):'- -'"></div>
                </div>
                <div class="mar-b-12"
                     v-if="itemRep.authorReplyFileList&& itemRep.authorReplyFileList.length>0">
                  <div class="ipub-p2 fw-bd fw-bd mar-b-4">Author Response File</div>
                  <div>
                    <ipub-label style="margin-right:10px;cursor:pointer"
                                class="ipub-p2"
                                type="link"
                                @click="download(itemfile,indexfile)"
                                v-for="(itemfile,indexfile) in itemRep.authorReplyFileList"
                                :key="itemfile.id">
                      {{itemfile.name}}
                      <ipub-icon type="iconDownload1"
                                 class="mar-l-10" />
                    </ipub-label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import main from './main'
export default main
</script>

<style lang="scss" scoped>
@import './main.scss';
</style>